export class Module {

    constructor({ type, id, label, children, hidden, icon, sidebarIcon }) {
        this.type = type;
        this.id = id;
        this.label = label;
        this.hidden = hidden;
        this.children = children;
        this.icon = icon;
        this.sidebarIcon = sidebarIcon;
    }

    static get Builder() {
        class Builder {
            constructor({ type, id, label, hidden, children, icon, sidebarIcon }) {
                this.type = type;
                this.id = id;
                this.label = label;
                this.hidden = hidden || false;
                this.children = children;
                this.icon = icon;
                this.sidebarIcon = sidebarIcon;
            }

            with(child) {
                if (this.children.find(c => c.id === child.id))
                    this.children = this.children.map(c => c.id === child.id ? child : c);
                else
                    this.children.push(child);
                return this;
            }

            build() {
                return new Module(this);
            }
        }
        return Builder;
    }
}
